// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue2535(props) {
    return (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 250 250"
            {...props}
        >
            <defs>
                <style>
                    {
                        '\n      .st0 {\n        fill: #aa8d49;\n      }\n\n      .st1 {\n        fill: #5b5b5b;\n      }\n\n      .st2, .st3, .st4, .st5 {\n        fill: #fff;\n      }\n\n      .st2, .st6 {\n        stroke-width: .8px;\n      }\n\n      .st2, .st6, .st4, .st5 {\n        stroke: #fff;\n      }\n\n      .st7, .st8 {\n        fill: #68836a;\n      }\n\n      .st9 {\n        fill: #a88b49;\n      }\n\n      .st8 {\n        font-family: ArialMT, Arial;\n        font-size: 11px;\n      }\n\n      .st10 {\n        fill: #7f7f7f;\n      }\n\n      .st6 {\n        fill: none;\n      }\n\n      .st4 {\n        stroke-width: .8px;\n      }\n\n      .st4, .st5 {\n        stroke-miterlimit: 4;\n      }\n\n      .st5 {\n        stroke-width: .7px;\n      }\n    '
                    }
                </style>
            </defs>
            <g id="Compass">
                <polygon
                    className="st1"
                    points="227 190.5 228.6 199.5 227.2 207.4 225.4 199.5 227 190.5"
                />
                <path
                    className="st10"
                    d="M226.8,183.9c8.5-.1,15.6,6.7,15.7,15.3.1,8.5-6.7,15.6-15.3,15.7-8.5.1-15.6-6.7-15.7-15.3-.1-8.5,6.7-15.6,15.3-15.7ZM227.2,213.6c7.8-.1,14.1-6.6,14-14.4-.1-7.8-6.6-14.1-14.4-14-7.8.1-14.1,6.6-14,14.4.1,7.8,6.6,14.1,14.4,14Z"
                />
                <path
                    className="st1"
                    d="M226.7,177.8c11.9-.2,21.7,9.4,21.9,21.3.2,11.9-9.4,21.7-21.3,21.9-11.9.2-21.7-9.4-21.9-21.3-.1-11.9,9.4-21.7,21.3-21.9ZM227.3,219c10.8-.2,19.5-9.1,19.3-19.9-.2-10.8-9.1-19.5-19.9-19.3-10.8.2-19.5,9.1-19.3,19.9.2,10.8,9.1,19.5,19.9,19.3Z"
                />
                <circle className="st1" cx={227} cy={199.4} r={3} />
                <path
                    className="st1"
                    d="M228.4,208.7v3.1h-.5l-1.4-2.1h0v2.1h-.5v-3.1h.5l1.4,2.1h0v-2.1h.5Z"
                />
                <circle className="st3" cx={227} cy={199.4} r={1.6} />
            </g>
            <g id="distances">
                <text className="st8" transform="translate(10.09 79.21)">
                    <tspan x={0} y={0}>
                        325
                    </tspan>
                </text>
                <text className="st8" transform="translate(114.55 26.37)">
                    <tspan x={0} y={0}>
                        404
                    </tspan>
                </text>
                <text className="st8" transform="translate(45.4 50.88)">
                    <tspan x={0} y={0}>
                        375
                    </tspan>
                </text>
                <text className="st8" transform="translate(189.49 50.88)">
                    <tspan x={0} y={0}>
                        375
                    </tspan>
                </text>
                <text className="st8" transform="translate(223.31 84.66)">
                    <tspan x={0} y={0}>
                        325
                    </tspan>
                </text>
            </g>
            <g id="field">
                <path
                    id="Outfield"
                    className="st9"
                    d="M126.5,227.7c-18.3,0-28.5-10.9-28.5-10.9l-.2-4-16.5-19.8h-4.3l-21.9-37.3-27.1-51.3-1.5-4.2s-2-13.5,4.5-22.2c8.5-11.5,58.8-43,82-46.2,0,0,12.2-4,26-.5s68.5,36.5,74.7,43c5.6,5.9,11,21.5,5,36.5s-15.2,31.8-16.5,37.3-24.5,43.8-27.3,45-4,0-4,0l-16.7,19.2.2,4.5c-.1-.2-9.6,10.9-27.9,10.9Z"
                />
                <path
                    id="grass"
                    className="st7"
                    d="M126.4,218.8c-16.6,0-25.8-9.9-25.8-9.9l-.2-3.6-15-17.9h-3.9l-19.9-33.8-24.7-47.1-1.4-3.9s-1.8-12.2,4.1-20.2c7.7-10.4,53.3-39,74.4-41.9,0,0,11-3.6,23.6-.5,12.5,3.2,62.1,33.1,67.7,39,5.1,5.4,10,19.5,4.5,33.1-5.4,13.6-13.6,29.3-14.8,34.3s-22.2,39.8-24.8,40.8c-2.6,1.1-3.6,0-3.6,0l-15.1,17.4.2,4.1s-8.6,10.1-25.3,10.1Z"
                />
                <path
                    id="infield_sand"
                    className="st0"
                    d="M101.7,170l-6.1,6.1,6.1,6.1c3.4-3.4,3.4-8.8,0-12.2ZM148.6,182.2l6.1-6.1-6.1-6.1c-3.3,3.4-3.3,8.8,0,12.2ZM131.2,152.6l-6.1-6.1-6.1,6.1c3.4,3.4,8.9,3.4,12.2,0ZM125.2,173.5c2.15,0,3.9,1.75,3.9,3.9s-1.75,3.9-3.9,3.9-3.9-1.75-3.9-3.9,1.75-3.9,3.9-3.9ZM125.2,197.8c3.09,0,5.6,2.51,5.6,5.6s-2.51,5.6-5.6,5.6-5.6-2.51-5.6-5.6,2.51-5.6,5.6-5.6Z"
                />
            </g>
            <g id="persistent">
                <g id="mound">
                    <path
                        id="pitching-mound"
                        className="st9"
                        d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4-1.4-1.5-3.9-1.5-5.4,0Z"
                    />
                    <path
                        id="pitching-rubber"
                        className="st2"
                        d="M123.2,176.6h4v1.6h-4v-1.6Z"
                    />
                </g>
                <g id="lines">
                    <path
                        id="left-foul-line"
                        className="st6"
                        d="M125.2,203.2L23.5,101.6"
                    />
                    <path
                        id="right-foul-line"
                        className="st6"
                        d="M125.2,203.2l99-99.1"
                    />
                </g>
                <g id="bases">
                    <rect
                        id="third-base"
                        className="st5"
                        x={99.18}
                        y={175.07}
                        width={3}
                        height={3}
                        transform="translate(-95.36 122.91) rotate(-45)"
                    />
                    <rect
                        id="first-base"
                        className="st5"
                        x={148.13}
                        y={175.16}
                        width={3}
                        height={3}
                        transform="translate(-81.09 157.55) rotate(-45)"
                    />
                    <rect
                        id="second-base"
                        className="st4"
                        x={123.67}
                        y={148.61}
                        width={3}
                        height={3}
                        transform="translate(-69.48 132.47) rotate(-45)"
                    />
                    <polygon
                        id="home"
                        className="st2"
                        points="126.7 201.8 125.2 203.4 123.7 201.8 123.7 200.3 126.7 200.3 126.7 201.8"
                    />
                </g>
            </g>
        </svg>
    )
}
export default Venue2535
